(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
    constructor() {
    super();
    }

    connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
    this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
    this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    }

    setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
    this.headerBounds = entries[0].intersectionRect;
    observer.disconnect();
    });

    observer.observe(this.header);
    }

    onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    this.header.classList.add('scrolled-past-header');
    if (this.preventHide) return;
    requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    this.header.classList.add('scrolled-past-header');
    if (!this.preventReveal) {
    requestAnimationFrame(this.reveal.bind(this));
    } else {
    window.clearTimeout(this.isScrolling);

    this.isScrolling = setTimeout(() => {
    this.preventReveal = false;
    }, 66);

    requestAnimationFrame(this.hide.bind(this));
    }
    } else if (scrollTop <= this.headerBounds.top) {
    this.header.classList.remove('scrolled-past-header');
    requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
    }

    hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
    }

    reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
    }
    }

    customElements.define('sticky-header', StickyHeader);
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radiant--collection-hero"] && !Shopify.designMode) return;
  try {
    
  const wrapper = document.querySelector('[js-collection-hero="wrapper"]')

  wrapper.addEventListener('radiant--slide-change', event => {
    wrapper.querySelectorAll('video').forEach(video => {
      if (!video) {
        return
      }

      if (video.paused) {
        video.play()
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radiant--header"] && !Shopify.designMode) return;
  try {
    
  const toggles = document.querySelectorAll('[js-menu-drawer="toggle"]');
  const backButtons = document.querySelectorAll('[js-menu-drawer="back"]');
  const menuDrawerClose = document.querySelector('[js-menu-drawer="close"]')
  const menuDrawerToggle = document.querySelector('[js-site-header="menu-drawer-toggle"]')

  menuDrawerToggle.addEventListener('click', () => {
    document.getElementById('menu-drawer').showModal()
  })

  menuDrawerClose.addEventListener('click', () => {
    document.getElementById('menu-drawer').close()
  })

  toggles.forEach(toggle => {
    toggle.addEventListener('click', event => {
      const rootElement = event.target.closest('[js-menu-drawer="tier-1"]')
      const nestedMenu = event.target.parentElement.nextElementSibling;

      nestedMenu.classList.add('is-active')
      rootElement.classList.remove('is-active')
      toggleCart(false)
    })
  })

  backButtons.forEach(button => {
    button.addEventListener('click', event => {
      const rootElement = event.target.closest('[js-menu-drawer="tier-1"]')
      const nestedMenu = event.target.parentElement.parentElement.parentElement;

      nestedMenu.classList.remove('is-active')
      rootElement.classList.add('is-active')
      toggleCart(true)
    })
  })

  function toggleCart(show) {
    const cart = document.querySelector('[js-menu-drawer="cart"]')

    if (show) {
      cart.classList.remove('is-hidden')
    } else {
      cart.classList.add('is-hidden')
    }
  }

  } catch(e) { console.error(e); }
})();
})();
